import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import data from "../utils/ListEnrolledCourses.json";

const ClassRoom = () => {
	// const navigate = useNavigate();
	// const [activeTab, setActiveTab] = useState("enrolled");
	// const [selectedCourse, setSelectedCourse] = useState(null); // State for the selected course
	// const [showModal, setShowModal] = useState(false); // State to show/hide modal
	// const [upcomingCourses, setUpcomingCourses] = useState([]);

	// useEffect(() => {
	//   setUpcomingCourses(data.courses.filter((course) => course.isUpcoming));
	// }, []);

	// const handleEnrollClick = (course) => {
	//   setSelectedCourse(course);
	//   setShowModal(true);
	// };

	// const closeModal = () => {
	//   setShowModal(false);
	//   setSelectedCourse(null);
	// };

	return (
		<div className="container mx-auto p-6 mt-20">
			<div className="courses-list grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
				{data.courses
					.filter((course) => course.isEnrolled)
					.map((course) => (
						<div
							key={course.id}
							className="course-card bg-gradient-to-bl from-blue-300 via-blue-50 to-white shadow-lg shadow-blue-600 rounded-lg overflow-hidden"
						>
							<img
								src={course.image}
								alt={course.title}
								className="w-32 h-32 object-cover rounded-full mx-auto mt-4"
							/>
							<div className="p-4 space-y-2">
								<h3 className="text-xl font-semibold text-center">
									{course.title}
								</h3>
								<p className="text-sm">{course.description}</p>
								<p className="text-gray-500 mt-2">
									Teacher: {course.teacher}
								</p>
								{course.isUpcoming ? (
									<button className="join-button bg-blue-500 text-white py-2 px-4 rounded mt-4 w-full">
										Join
									</button>
								) : (
									<CountdownTimer
										startTime={course.startTime}
										courseId={course.id}
									/>
								)}
							</div>
						</div>
					))}
			</div>
		</div>
	);
};

const CountdownTimer = ({ startTime, courseId }) => {
	const navigate = useNavigate();
	const [timeLeft, setTimeLeft] = useState(getTimeLeft(startTime));
	const [hasStarted, setHasStarted] = useState(false);

	useEffect(() => {
		const timer = setInterval(() => {
			const newTimeLeft = getTimeLeft(startTime);
			setTimeLeft(newTimeLeft);
			if (newTimeLeft === "Live Session Started") {
				setHasStarted(true);
			}
		}, 1000);

		return () => clearInterval(timer);
	}, [startTime]);

	return (
		<div className="timer text-center mt-4">
			{hasStarted ? (
				<div onClick={() => navigate(`/ClassRoom/${courseId}`)}>
					<button className="join-button bg-blue-500 text-white py-2 px-4 rounded w-full">
						Join live
					</button>
				</div>
			) : (
				timeLeft
			)}
		</div>
	);
};

const getTimeLeft = (startTime) => {
	const now = new Date();
	const diff = new Date(startTime) - now;

	if (diff <= 0) return "Live Session Started";

	const hours = Math.floor(diff / (1000 * 60 * 60));
	const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
	const seconds = Math.floor((diff % (1000 * 60)) / 1000);

	return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
		2,
		"0"
	)}:${String(seconds).padStart(2, "0")}`;
};

export default ClassRoom;
